import Button from "@edaz/edazkit/Button/index";
import { registerView } from "@frui.ts/views";
import type { ViewComponent } from "@frui.ts/views/dist";
import { View } from "@frui.ts/views/dist";
import { Observer, observer } from "mobx-react-lite";
import React from "react";
import ActionsViewModel from "viewModels/callCenter/actions/actionsViewModel";

export const ActionsView: ViewComponent<ActionsViewModel> = observer(({ vm }) => {
  return (
    <>
      <div className="d-flex bg-white rounded p-4 h-100 flex-column">
        <Button className="rounded mb-3" block={true} variant="light" onClick={vm.onBulkExemptionsClick}>
          {vm.translate("bulkExemptions.name")}
        </Button>
        <Button className="rounded mb-3" block={true} variant="light" onClick={vm.onDistributorStornoClick}>
          {vm.translate("distributorStorno.add")}
        </Button>
        <Button className="rounded mb-3" block={true} variant="primary" onClick={vm.onChangeVehicleClick}>
          {vm.translate("vehicleChange.add")}
        </Button>
      </div>
      <Observer>{() => <View vm={vm.activeChild} />}</Observer>
    </>
  );
});

registerView(ActionsView, ActionsViewModel);
